import axiosInstance from '../../utils/axiosInstance';
import endpoints from '../../utils/endpoints';

const find = async (query = {}) => {
  const { data } = await axiosInstance.get(endpoints.coinSpendCodes(), { params: query });
  return data;
};

const findByObject = async (objectId) => {
  const res = await axiosInstance.get(endpoints.coinSpendCodes(`by-object/${objectId}`));
  const data = res.data;
  return Array.isArray(data) ? data : data?.data ?? [];
};

const findOne = async (id) => {
  const { data } = await axiosInstance.get(endpoints.coinSpendCodes(id));
  return data;
};

const create = async (payload) => {
  const { data } = await axiosInstance.post(endpoints.coinSpendCodes(), { data: payload });
  return data;
};

const update = async (id, payload) => {
  const { data } = await axiosInstance.put(endpoints.coinSpendCodes(id), { data: payload });
  return data;
};

const remove = async (id) => {
  const { data } = await axiosInstance.delete(endpoints.coinSpendCodes(id));
  return data;
};

/**
 * Spend coins using a QR code (authenticated).
 * @param {string} codeDocumentId - documentId of the coin-spend-code (from QR)
 * @returns {Promise<{ success, spent, spentCoinsTotal, availableCoins, collectedGoldCoins }>}
 */
const spend = async (codeDocumentId) => {
  const { data } = await axiosInstance.post(endpoints.coinSpendCodes('spend'), {
    data: { codeDocumentId },
  });
  return data;
};

const client = { find, findByObject, findOne, create, update, remove, spend };

export default client;
